import React, { useEffect } from 'react';
import { DispatchFunction, failed, submitted, succeded } from './usePageWatchUpdate';
import { PageWatchState, PageWatchProps } from './PageWatch';
import { getButtonModifier, iconLookup } from './iconLookup';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { SonForm, useForm } from '../../../../_lib/Form2';
import { Namespace } from '../../../../translation/namespace';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { BtnModifier } from '../../../../components/molecules/Btn';
import { Button } from '../../../../components/molecules/Btn/Button';

export type ChangeWatchForm = SonForm<never>; // form without parameters
type ChangeWatchFormProps = {
  state: PageWatchState;
  form: ChangeWatchForm;
  dispatchAction: DispatchFunction;
};
export function ChangeWatchForm({ state, form, dispatchAction }: ChangeWatchFormProps) {
  const { t } = useSonTranslation(Namespace.PageInteractionsWatchButton);

  const { formProps, fetchState } = useForm<ChangeWatchForm, PageWatchProps>({
    form,
  });

  useEffect(() => {
    switch (fetchState.type) {
      case 'error':
        dispatchAction(failed('meeeh'));
        break;
      case 'loading':
        dispatchAction(submitted());
        break;
      case 'success':
        dispatchAction(succeded(fetchState.response.data));
        break;
      default:
        break;
    }
  }, [dispatchAction, fetchState]);

  return (
    <form id={`watch-state-${state}`} {...formProps}>
      <Button
        type="submit"
        title={t(`${state}.actionButtonText`)}
        tooltipPlacement={TooltipPlacement.LEFT}
        hideTooltipFromScreenReader
        modifier={[...getButtonModifier(state), BtnModifier.MICRO_INTERACTION]}
      >
        <Button.Icon svgSpriteId={iconLookup[state]} text={t(`${state}.actionButtonText`)} />
      </Button>
    </form>
  );
}
